import {
    ColoursObj,
    Icon,
    TEventrIcons,
    Typography,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { CountLabel } from './CountLabel'

interface IBreakoutSectionProps {
    title: string
    icon: TEventrIcons
    count?: number
    onClick?: () => void
    colour?: string
    borderColour?: string
    iconColour?: string
}
export const BreakoutSection = ({
    title,
    count = 0,
    icon,
    onClick,
    colour = ColoursObj.core.primary,
    iconColour = ColoursObj.core.primary,
    borderColour = ColoursObj.shades.shade2,
}: IBreakoutSectionProps) => {
    return (
        <Stack padding={'18px 8px'} borderBottom={'1px solid ' + borderColour}>
            <Stack
                direction="row"
                justifyContent="space-between"
                onClick={() => {
                    onClick?.()
                }}
            >
                <Stack direction="row" spacing="16px">
                    <Icon bubble name={icon} bubbleColour={iconColour} />
                    <Typography
                        variant="bodyBold"
                        id={`disclosureGroupTitleSection${title}Id`.replace(
                            /\s+/g,
                            ''
                        )}
                    >
                        {title}
                    </Typography>
                </Stack>

                <Stack direction="row" spacing="8px">
                    {count > 0 && (
                        <CountLabel
                            id={title.toLowerCase().replace(/\s+/g, '')}
                            text={count}
                            bgColor={colour}
                        />
                    )}

                    <Icon iconColour={colour} name="Chevron_Right" />
                </Stack>
            </Stack>
        </Stack>
    )
}
